import React from 'react';
import { LoaderContainer, FlexContainer, DetailsContainer } from './styles.js';

export default function LoaderCard() {
  return (
    <LoaderContainer>
      <DetailsContainer width="100" height="180" isImage />
      <FlexContainer content="space-between">
        <DetailsContainer width="50" height="22" />
        <DetailsContainer width="15" height="18" />
      </FlexContainer>
      <FlexContainer>
        <DetailsContainer width="30" height="20" />
        <DetailsContainer width="30" height="20" />
      </FlexContainer>
      <FlexContainer>
        <DetailsContainer width="55" height="16" />
      </FlexContainer>
    </LoaderContainer>
  );
}
